<template>
  <section>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(save_performance_activity)">
        <div class="modal-card" style="width: 1000px">
          <header class="modal-card-head">
            <p class="modal-card-title">Declarar Horas Realizadas</p>
            <button type="button" class="delete" @click="$emit('close')" />
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <b-field label="Actividad Académica">
                  <b-input
                    v-model="performanceActivity.activity_name"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
              <div v-if="asignatura" class="column">
                <b-field label="Asignatura">
                  <b-input
                    v-model="asignatura.codigo_nombre"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Tipo de horas">
                  <b-input v-model="tipo_hora" disabled="true"></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Horas comprometidas 1er semestre">
                  <b-input
                    v-model="performanceActivity.hours_committed_semester_1"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Horas comprometidas 2do semestre">
                  <b-input
                    v-model="performanceActivity.hours_committed_semester_2"
                    disabled="true"
                  ></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Horas realizadas 1er semestre*">
                  <validation-provider
                    rules="required|numeric|min_value:0"
                    v-slot="{ errors }"
                  >
                    <b-input
                      v-model="performanceActivity.hours_completed_semester_1"
                    ></b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </validation-provider>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Horas realizadas 2do semestre*">
                  <validation-provider
                    rules="required|numeric|min_value:0"
                    v-slot="{ errors }"
                  >
                    <b-input
                      v-model="performanceActivity.hours_completed_semester_2"
                    ></b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </validation-provider>
                </b-field>
              </div>
              <div v-if="asignatura" class="column is-narrow">
                <br />
                <b-field label=" ">
                  <b-button
                    type="is-primary"
                    icon-left="plus"
                    @click="openModalSaiHours"
                  >
                    Completar Horas con SAI
                  </b-button>
                </b-field>
              </div>
            </div>
            <div class="columns has-text-centered">
              <div class="column">
                <b-field
                  extended
                  label="Agregar Evidencias (Word, Excel, PDF, JPEG y PNG)"
                >
                  <b-upload
                    v-model="files"
                    drag-drop
                    multiple
                    type="is-primary"
                    accept=".docx,.pdf,.doc,.xlsx,.png,.jpeg"
                  >
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Arrastra tu archivo o haz click aquí.</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
                <div class="tags">
                  <span
                    v-for="(file, index) in files"
                    :key="index"
                    class="tag is-primary"
                  >
                    {{ file.name }}
                    <button
                      class="delete is-small"
                      type="button"
                      @click="deleteDropFile(index)"
                    ></button>
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
        <footer class="modal-card-foot">
          <div class="actions has-text-right">
            <button class="button" type="button" @click="$emit('close')">
              Cerrar
            </button>
            <button class="button is-primary" type="submit">Actualizar</button>
          </div>
        </footer>
      </form>
    </ValidationObserver>
    <b-modal
      :active.sync="isActiveModalSaiHours"
      :width="800"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
      aria-label="Modal para completar horas con SAI"
    >
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Horas Realizadas</p>
        </header>
        <div class="card-content">
          <b-table
            paginated
            per-page="10"
            :pagination-simple="false"
            pagination-position="bottom"
            aria-next-label="Siguiente"
            aria-previous-label="Anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
            :data="filteredSubjects"
          >
            <b-table-column field="codigo" label="Código" v-slot="props">
              {{ props.row.codigo }}
            </b-table-column>
            <b-table-column
              field="asignatura"
              label="Asignatura"
              v-slot="props"
            >
              {{ props.row.asignatura }}
            </b-table-column>

            <b-table-column field="semestre" label="Semestre" v-slot="props">
              {{ props.row.semestre }}
            </b-table-column>
            <b-table-column field="horario" label="Horario" v-slot="props">
              {{ props.row.horario }}
            </b-table-column>
            <b-table-column field="tel" label="TEL" v-slot="props">
              {{ props.row.tel }}
            </b-table-column>
            <b-table-column
              field="total_hours"
              label="Horas Totales"
              v-slot="props"
            >
              {{ props.row.total_hours }}
            </b-table-column>
          </b-table>
        </div>
        <footer class="modal-card-foot">
          <div class="actions has-text-right">
            <button
              class="button"
              type="button"
              @click="isActiveModalSaiHours = false"
            >
              Cerrar
            </button>
            <button
              class="button is-primary"
              type="button"
              @click="completeHoursWithSai"
            >
              Completar horas
            </button>
          </div>
        </footer>
      </div>
    </b-modal>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "modalAddHours",
  props: {
    activityId: {
      type: Number,
      required: true,
    },
    subjects: {
      type: Array,
      required: true,
    },
    subjectsSemester1: {
      type: Array,
      required: true,
    },
    subjectsSemester2: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      performanceActivity: {
        activity_name: "",
      },
      isLoading: false,
      tipo_hora: "Semanales",
      files: null,
      asignatura: null,
      isActiveModalSaiHours: false,
      filteredSubjects: [],
      totalHoursSemester1: 0,
      totalHoursSemester2: 0,
    };
  },
  created() {
    this.get_performance_activity();
  },
  methods: {
    get_performance_activity() {
      this.isLoading = true;
      axios
        .get(`/activity_performances/${this.activityId}.json`)
        .then((response) => {
          this.performanceActivity = response.data;
          if (this.performanceActivity.is_weekly_hours) {
            this.tipo_hora = "Semanales";
          } else {
            this.tipo_hora = "Semestrales";
          }
          if (
            this.performanceActivity.subject_code === null ||
            this.performanceActivity.subject_code === undefined
          ) {
            this.asignatura = null;
          } else {
            this.asignatura = this.subjects.find(
              (subject) =>
                subject.codigo ===
                parseInt(this.performanceActivity.subject_code)
            );
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    deleteDropFile(index) {
      this.files.splice(index, 1);
    },
    save_performance_activity() {
      let formData = new FormData();
      formData.append(
        "hours_completed_semester_1",
        this.performanceActivity.hours_completed_semester_1
      );
      formData.append(
        "hours_completed_semester_2",
        this.performanceActivity.hours_completed_semester_2
      );
      // Iterar sobre cada archivo y agregarlo individualmente
      if (this.files && this.files.length > 0) {
        this.files.forEach((file, index) => {
          formData.append("files[]", file);
        });
      }

      this.isLoading = true;
      axios
        .post(
          `/activity_performances/declare-completed-hours/${this.activityId}.json`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.$emit("close");
          this.$emit("refresh");
          this.$buefy.toast.open({
            message: "Horas declaradas correctamente",
            type: "is-success",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              error.response.data.error ||
              "Hubo un error al guardar los archivos. Por favor, inténtelo nuevamente.",
            type: "is-danger",
            hasIcon: true,
            icon: "alert-circle-outline",
            iconPack: "mdi",
            ariaRole: "alertdialog",
            ariaModal: true,
            onConfirm: () => {},
          });
          this.isLoading = false;
        });
    },
    openModalSaiHours() {
      const filteredSubjectsSemester1 = this.subjectsSemester1.filter(
        (subject) =>
          subject.codigo === parseInt(this.performanceActivity.subject_code)
      );
      const filteredSubjectsSemester2 = this.subjectsSemester2.filter(
        (subject) =>
          subject.codigo === parseInt(this.performanceActivity.subject_code)
      );

      if (
        filteredSubjectsSemester1.length === 0 &&
        filteredSubjectsSemester2.length === 0
      ) {
        this.$buefy.dialog.alert({
          title: "Error",
          message:
            "No registra horas realizadas de esta asignatura en SAI. Ingrese las horas manualmente.",
          type: "is-danger",
          hasIcon: true,
          iconPack: "fa",
          icon: "times-circle",
          confirmText: "Ok",
          onConfirm: () => (this.isActiveModalSaiHours = false),
        });
        return;
      }

      let horasSemestre1 = 0;
      let horasSemestre2 = 0;
      filteredSubjectsSemester1.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre1 += hour_t + hour_e + hour_l;
        this.filteredSubjects.push({
          ...subject,
          total_hours: hour_t + hour_e + hour_l,
          semestre: "1er Semestre",
        });
      });
      filteredSubjectsSemester2.forEach((subject) => {
        const tel = subject.tel.split("-");
        const hour_t = parseInt(tel[0]) || 0;
        const hour_e = parseInt(tel[1]) || 0;
        const hour_l = parseInt(tel[2]) || 0;
        horasSemestre2 += hour_t + hour_e + hour_l;
        this.filteredSubjects.push({
          ...subject,
          total_hours: hour_t + hour_e + hour_l,
          semestre: "2do Semestre",
        });
      });
      this.totalHoursSemester1 = horasSemestre1;
      this.totalHoursSemester2 = horasSemestre2;

      this.isActiveModalSaiHours = true;
    },
    completeHoursWithSai() {
      this.performanceActivity.hours_completed_semester_1 =
        this.totalHoursSemester1;
      this.performanceActivity.hours_completed_semester_2 =
        this.totalHoursSemester2;
      this.isActiveModalSaiHours = false;
      this.filteredSubjects = [];
      this.$buefy.toast.open({
        message: "Horas completadas con SAI correctamente",
        type: "is-success",
      });
    },
  },
};
</script>

<style scoped></style>
